/**
  * @memberof checkVarType
  * @name isValidVar
  * Check if a variable is not undefined nor null
  * @param {any} x variable to be checked
  * @returns {boolean} is the variable a valid one?
*/
const isValidVar = (x) => typeof x !== 'undefined' && x !== null;

export default isValidVar;
